export default __webpack_public_path__ + "static/media/marcos.4099e057.jpg";